// TODO Consider using `Interface.implementArray(DTD, o.sectionstatus);` or `ArrayListBuilder(o.sectionstatus, DTD)`
angular
  .module('capability-ng-scheduler')
  .factory('SectionStatusCollectionBuilder', function SectionStatusCollectionBuilder(Interface) {
    var DTD = {
      sectionstatus: {
        type: 'ngObject',
        typeDef: 'SectionStatusBuilder'
      }
    };

    function SectionStatusCollectionDTO(data) {
      Interface.implement(DTD, data, this);
    }

    return SectionStatusCollectionDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/section_status_collection_builder.es.js